import { Component, Inject } from "@angular/core";
import { FormGroup, AbstractControl } from "@angular/forms";
import { Utilities } from "@tylertech/shared-module";
import { BehaviorSubject, Observable, Subscription } from "rxjs";
import { LgdFormControlFactory } from "@tylertech/lgd-reactive-forms";
import { KeyValue } from "@tylertech/tyler-api-types";
import { CachedCodeLookupService } from "@tylertech/metadata-module";
import { ODataFilterFactoryService } from "@tylertech/odata-module";
import { UserProfileService } from "@tylertech/core-module";

@Component({
    selector: "user-lookup-card",
    templateUrl: "./userLookup.tmpl.html",
    styleUrls: [
        "./userLookup.component.scss"
    ],
    standalone: false
})
export class UserLookupCardComponent
{
    lookupType: string;

    showCard: boolean = false;

    loading: boolean = false;

    initialized: boolean = false;

    selectedUserId;

    entity: any;

    hasEntity: boolean = false;

    private readonly subscriptions: Subscription[] = [];

    readonly userLookupForm: FormGroup;

    private get userLookupFormControl(): AbstractControl
    {
        return this.userLookupForm.get("user");
    }

    private readonly userLookupSubject: BehaviorSubject<any[]>;

    get userLookupObservable(): Observable<any[]>
    {
        return this.userLookupSubject.asObservable();
    }

    constructor(
        private $userProfileService: UserProfileService,
        private $cachedCodeLookupService: CachedCodeLookupService,
        private readonly $odataFilterFactory: ODataFilterFactoryService
    )
    {
        this.userLookupSubject = new BehaviorSubject([]);
        const self = this;
        this.userLookupForm = new FormGroup({
            user: LgdFormControlFactory.typeahead(null, false, {
                displayValueFn: x => self.getUserText(x),
                valueFn: x => self.getUserValue(x),
            }),
        });
        this.$userProfileService.GetUserLookupType()
            .then(x =>
            {
                if (!Utilities.IsNullOrUndefined(x))
                {
                    self.lookupType = x;
                    self.showCard = true;
                    self.initialized = true;
                    self.lookupUser("");
                }
            });
    }

    ngOnInit(): void
    {
        this.subscriptions.push(
            this.userLookupFormControl.valueChanges.subscribe(x =>
            {
                this.selectedUserId = x;
            })
        );
    }

    lookupUser(searchText: string): void
    {
        const self = this;
        this.getUsers(searchText)
            .then(results =>
            {
                if (results.length === 1)
                {
                    self.userLookupFormControl.setValue(results[0].Key);
                }
                self.userLookupSubject.next(results);
            });
    }

    getUsers(searchText: string): Promise<any[]>
    {
        const self = this;
        const odataFilterBuilder = this.$odataFilterFactory.createBuilderFor<KeyValue>();
        odataFilterBuilder.like("Value", Utilities.toLower(searchText));
        const filterString = odataFilterBuilder.build();
        if (Utilities.IsNullOrUndefined(filterString)) return Promise.resolve([]);
        return self.$cachedCodeLookupService.Get(this.lookupType, filterString)
            .catch(onError);
        function onError(error): Array<any>
        {
            console.error(
                `getUsers|lookupType: ${JSON.stringify(this.lookupType)}|filter: ${JSON.stringify(filterString)}`,
                error
            );
            return [];
        }
    }

    getUserValue(user: any): string
    {
        return user ? user.Key : null;
    }

    getUserText(user: any): string
    {
        return user ? user.Value : null;
    }
}
